module.exports = __webpack_public_path__ + "common/icon-cancel-f97cb0d578992abb53f89bb55a07f82b.svg";